import React from 'react';
import PropTypes from 'prop-types';
import './SurveyForm.css';
import RouteTitle from 'components/shared/route-title/RouteTitle';
import SurveyRating from 'components/admin/surveys/SurveyRating';
import Button from 'components/shared/button/Button';
import Date from 'components/shared/text/Date';
import SurveyQuestion from 'components/admin/surveys/SurveyQuestion';
import TextArea from 'components/shared/input/TextArea';

export default function SurveyForm(props) {
  const {
    edit,
    showValidationMessage,
    survey,
    onAttributeChange,
    onCancel,
    onSubmit,
  } = props;
  return (
    <div className="survey-form">
      <div className="top-container">
        <RouteTitle titles={['WORK ORDERS', survey.wo_number.toString()]} />
        <div className="title-container">
          <div className="work-order-title-container">
            <span className="work-order-title">{`Survey Work Order #${survey.wo_number}`}</span>
            <SurveyRating rating={survey.rating} />
          </div>
        </div>
        {survey.rating !== null && survey.rating > 0 && (
          <div className="submitted-container">
            Survey Submitted on{' '}
            <Date value={survey.updated_at} format="M/D/YYYY" />
          </div>
        )}
      </div>
      <div className="survey-form-container">
        <SurveyQuestion
          edit={edit}
          title="1. Was the response time satisfactory?"
          value={survey.response_time_sat}
          onChange={(value) => onAttributeChange('response_time_sat', value)}
        />
        <div className="question-separator" />
        <SurveyQuestion
          edit={edit}
          title="2. Was the quality of work satisfactory?"
          value={survey.work_quality_sat}
          onChange={(value) => onAttributeChange('work_quality_sat', value)}
        />
        <div className="question-separator" />
        <SurveyQuestion
          edit={edit}
          title="3. Would you recommend Spackle?"
          value={survey.recommend_spackle}
          onChange={(value) => onAttributeChange('recommend_spackle', value)}
        />

        <div className="note-container">
          {edit ? (
            <TextArea
              value={survey.note !== null ? survey.note : ''}
              onChange={(value) => onAttributeChange('note', value)}
            />
          ) : (
            <div className="note-readonly">{survey.note}</div>
          )}
        </div>

        {edit && showValidationMessage && (
          <div className="invalid-form-message">
            Please answer all questions before submitting.
          </div>
        )}

        {edit && (
          <div className="buttons-container">
            <Button
              className="button-orange"
              label="Submit"
              onClick={() => onSubmit()}
            />
            <Button
              className="button-gray"
              label="Cancel"
              onClick={() => onCancel()}
            />
          </div>
        )}
      </div>
    </div>
  );
}

SurveyForm.propTypes = {
  edit: PropTypes.bool,
  showValidationMessage: PropTypes.bool,
  survey: PropTypes.shape({}).isRequired,
  onAttributeChange: PropTypes.func,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

SurveyForm.defaultProps = {
  edit: false,
  showValidationMessage: false,
  onAttributeChange: () => {},
  onCancel: () => {},
};



// WEBPACK FOOTER //
// ./src/components/admin/surveys/SurveyForm.js